import { api } from '@/core/api/';
import qs from 'qs';

const URL = 'api/provider/thrpybilling';
const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const getMonthsInAcademicYear = (academicYearId) =>
  api.get(`${URL}/months/${academicYearId}`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'indices' }),
  });

export const getBillingDetails = (billId) => {
  return api.get(`${URL}/${billId}`);
};

export const updateBillingAmounts = (billId) => {
  return api.put(`${URL}/${billId}`);
};

export const createBill = (payload) => {
  return api.post(`${URL}/create`, payload);
};

export const getHistory = (billId, pageIndex, pageSize) => {
  return api.get(`${URL}/billingHistory/${billId}/${pageIndex}/${pageSize}`);
};

export const getBillingStatusTransition = (billId) => {
  return api.get(`${URL}/getbillingstatustransition/${billId}`);
};

export const updateBillingStatus = (payload) => {
  return api.put(`${URL}/updatebillingstatus`, payload);
};

export const submitBillValidation = (payload) => {
  return api.post(`${URL}/submitbill`, payload);
};

export const getAdjustmentsummary = (billId) => {
  return api.get(`${URL}/adjustmentsummary/${billId}`);
};

export const getAdjustmentReasonlist = (billId) => {
  return api.get(`${URL}/adjustmentreasonlist/${billId}`);
};
export const getAllAdjustment = (payload) => {
  return api.get(`${URL}/adjustments/`, {
    params: {
      ...payload,
    },
  });
};
export const removeAdjustment = (billingAdjustmentId) => {
  return api.put(`${URL}/adjustment/remove/${billingAdjustmentId}`);
};
export const submitObjection = (payload) => {
  return api.post(`${URL}/adjustmentobjection/save`, payload, header);
};
export const submitAjusmentAcepted = (payload) => {
  return api.post(`${URL}/adjustmentobjection/updatestatus`, payload);
};

export const getPaymentDetail = (billId) => {
  return api.get(`${URL}/payment/${billId}`);
};
export const submitException = (payload) => {
  return api.post(`${URL}/saveException/`, payload);
};
export const getDays = () => {
  return api.get(`${URL}/exceptionDays`);
};
export const removeObjection = (billingAdjustmentId) => {
  return api.put(`${URL}/adjustmentobjection/remove/${billingAdjustmentId}`);
};
export const processBills = (bills) => api.post(`${URL}/processBills`, bills);

export const validateBill = (payload) =>
  api.get(`${URL}/validateBill`, {
    params: {
      ...payload,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'indices' }),
  });

export const hasDocumentExpired = (billId) =>
  api.get(`${URL}/hasdocumentexpired/${billId}`);

  export const hasdocumentexpiredConditionalApproval = (billId) =>
  api.get(`${URL}/hasdocumentexpiredConditionalApproval/${billId}`);
